export default {"src":"/_next/static/media/tipIcon.11ee6812.svg","height":24,"width":25,"blurWidth":0,"blurHeight":0};